module.exports = __webpack_public_path__ + "static/media/Contents.1d314bae.svg";